module.exports = __webpack_public_path__ + "static/img/Logo2_CathayPacificAirway.3749ec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo2_CathayPacificAirway.png
// module id = 308
// module chunks = 2